import { loginStaff, uploadConsultantImage } from './services'

const getDefaultState = () => {
  return {
    data: null
  }
}

const state = getDefaultState()

const getters = {
  isAuthenticated: (state) => !!state.data,
  getData: (state) => state.data
}

const actions = {
  async loginStaffAction ({ commit, dispatch }, { username, password }) {
    dispatch('spinner/updateLoadingAction', true, { root: true })
    const res = await loginStaff(username, password)
    if (res && res.username) {
      commit('loginStaffSuccess', res)
      dispatch('spinner/updateLoadingAction', false, { root: true })
      return true
    } else {
      dispatch('spinner/updateLoadingAction', false, { root: true })
      dispatch('flashMessage/set', { type: 'error', message: 'Sorry, we don\'t recognise those details. Please check and try again.' }, { root: true })
      return false
    }
  },
  async uploadConsultantImageAction ({ dispatch }, data) {
    dispatch('spinner/updateLoadingAction', true, { root: true })
    const res = await uploadConsultantImage(data)
    if (res && res.username) {
      dispatch('spinner/updateLoadingAction', false, { root: true })
      dispatch('flashMessage/set', { type: 'success', message: 'Upload finished.' }, { root: true })
      return true
    } else {
      dispatch('spinner/updateLoadingAction', false, { root: true })
      dispatch('flashMessage/set', { type: 'error', message: 'Upload failed.' }, { root: true })
      return false
    }
  },
  resetStateAction ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  loginStaffSuccess (state, data) {
    state.data = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  getters,
  namespaced: true,
  state,
  actions,
  mutations
}
